<template>
  <svg
    id="Wallet-2--Streamline-Nova"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
  >
    <desc>Wallet 2 Streamline Icon: https://streamlinehq.com</desc>
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M4 1C2.34315 1 1 2.34315 1 4v10.7263c0 1.1655 0.67512 2.2256 1.73135 2.7185l10.99995 5.1334c1.989 0.9281 4.2687 -0.5237 4.2687 -2.7186V17h2c1.6569 0 3 -1.3431 3 -3V4c0 -1.65685 -1.3431 -3 -3 -3H4Zm14 9.2737V15h2c0.5523 0 1 -0.4477 1 -1V4c0 -0.55228 -0.4477 -1 -1 -1H6.50757l9.76113 4.55517C17.3249 8.04808 18 9.10815 18 10.2737Zm-4 3.6453c0 0.8284 -0.6716 1.5 -1.5 1.5s-1.5 -0.6716 -1.5 -1.5 0.6716 -1.5 1.5 -1.5 1.5 0.6716 1.5 1.5Z"
      clip-rule="evenodd"
      stroke-width="1"
    ></path>
  </svg>
</template>
